/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TemplateMedication from './template-medication';
import TemplateMedicationDetail from './template-medication-detail';
import TemplateMedicationUpdate from './template-medication-update';
import TemplateMedicationDeleteDialog from './template-medication-delete-dialog';

const TemplateMedicationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TemplateMedication />} />
    <Route path="new" element={<TemplateMedicationUpdate />} />
    <Route path=":id">
      <Route index element={<TemplateMedicationDetail />} />
      <Route path="edit" element={<TemplateMedicationUpdate />} />
      <Route path="delete" element={<TemplateMedicationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TemplateMedicationRoutes;
